export default __webpack_public_path__ + "static/homepage-waste-not-e4e904c83ea8ea2b05b6310629b9c0c1.png";